module.exports = __webpack_public_path__ + "static/media/logo-green@200x.2619e691.png";